import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';
import {I18n} from '@aws-amplify/core';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteRecord} from "../services/ProductLineItemsService.ts";
import {useProductLineItemsSelection} from "../hooks/useProductLineItemsSelection.ts";
import {productLineItemsQueryKeys} from "../hooks/productLineItemsQueryKeys.ts";
import {notifyError, notifySuccess} from '../../../components/ServiceNotifications';

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useProductLineItemsSelection();
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async () => {
            await Promise.all(selectedRecords.map(record => deleteRecord(record.id)));
        },
        onSuccess: () => {
            clearSelection();
            notifySuccess(I18n.get('Product Line Item deleted'));
        },
        // A failed delete is visible, and the selection is kept so it can be retried.
        onError: notifyError,
        // Some of a batch may have gone even when another failed, so refetch either way.
        onSettled: () => queryClient.invalidateQueries({queryKey: productLineItemsQueryKeys.all}),
    });

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0}
            recordIdsLength={selectedRecords.length}
            handleConfirm={() => mutation.mutate()}
        />
    );
};
